import React from 'react';
const Imenu = function() {
    return (
        <>
            <span id="i-search" /><span id="i-menu" />
        </>
    );
}
export default Imenu;